<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 22V9H2l10-7 10 7h-9v13h-2Zm1-15h3.65-7.3H12ZM3 22v-5.25l-.8-4.4L4.15 12l.75 4H9v6H7v-4H5v4H3Zm12 0v-6h4.1l.75-4 1.95.35-.8 4.4V22h-2v-4h-2v4h-2ZM8.35 7h7.3L12 4.45 8.35 7Z"
    />
  </svg>
</template>
